/**
 * @description Hook to get the plan permissions from the auth context
 * @returns {PlanPermissions} The plan permissions object
 */
import { useMemo } from "react";
import { usePlan } from "@/features/auth/hooks/usePlan";
import type { PlanFeatures } from "@/features/auth/types/plan.type";

export const usePlanPermissions = () => {
  const plan = usePlan();

  const permissions = useMemo(() => {
    if (!plan) {
      return {
        canAccessTopUp: false,
        canAccessVouchers: false,
        canAccessCards: false,
        canAccessSupport: false,
      };
    }

    return {
      canAccessTopUp: plan.features.service_topup,
      canAccessVouchers: plan.features.service_vouchers,
      canAccessCards: plan.features.service_card,
      canAccessSupport: plan.features.service_support,
    };
  }, [plan]);

  const hasPermission = (feature: keyof PlanFeatures): boolean => {
    if (!plan) return false;
    return plan.features[feature] ?? false;
  };

  return {
    plan,
    permissions,
    hasPermission,
  };
};
